<template>
  <div style="height: 400px;">
    <el-scrollbar>
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box title-h3">변수 목록</div>
        <div class="vertical-center-box" align="right">
          <w-header-search-button size="mini" @click="showVariableSearchTool = !showVariableSearchTool"></w-header-search-button>
        </div>
      </el-row>
      <el-table-wrapper ref="variableTable" :column-default="columnDefault" :data="variableList" :columns="tableColumns" @pagination-change="handlerPaginationChange"
      :show-search-tool="showVariableSearchTool" :show-custom-header="true" remote pagination @condition-change="loadData" :total="variableTotal" >
      </el-table-wrapper>
    </el-scrollbar>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import { columnDefault, defaultPagination } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';
import amsSettingsApi from '@/api/settings/server/ams-settings';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);
const pagination = cloneDeep(defaultPagination);

export default {
  name: 'WTaskDefValueTable',
  data() {
    const tableColumns = [
      { prop: 'variableId', label: '변수 아이디', searchable: true, sortable: true, remoteProp: 'variable_id' },
      { prop: 'variableName', label: '변수명', searchable: true, sortable: true, remoteProp: 'variable_name' },
      { prop: 'variableDefaultValue', label: '변수값', formatter: defaultFormatter },
    ];
    return {
      columnDefault,
      tableColumns,
      showVariableSearchTool: false,
      variableTotal: 0,
      variableList: [],
      pagination,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      const variableTable = this.$refs.variableTable;
      const tableParams = variableTable.getParameter();
      amsSettingsApi.getVariableList(tableParams).then((response) => {
        if (response.data.success) {
          this.variableList = response.data.data;
          this.variableTotal = response.data.total;
        }
      });
    },
    handlerPaginationChange(_pagination) {
      this.pagination = _pagination;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/TaskSetting/components/TaskDefValueTable.vue